<template>
  <div v-if="productData" id="_layout">
    <div>
      <div class="hero hero--large">
        <div class="child">
          <ClientLogo
            :isExperience="isExperienceHeader"
            class="logo"
            color="white"
          />
        </div>
        <figure class="hero_image image image-no-bg is-shown">
          <picture class="covered">
            <img v-if="productData.coverImage" :src="`${productData.coverImage}`" />
          </picture>
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ClientLogo from '@/components/ui/ClientLogo.vue'

export default {
  components: {
    ClientLogo,
  },
  data() {
    return {
      productData: null,
      errored: false,
      loading: true,
      baseUrl: process.env.VUE_APP_API_URL,
    }
  },
  mounted() {
    axios
      .get(
        this.isExperienceHeader
          ? `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/experience/${this.$route.params.experienceUUID}`
          : `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/product/${this.$route.params.productUUID}`
      )
      .then((response) => {
        this.productData = response.data
      })
      .catch((error) => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))
  },
  props: {
    isExperienceHeader: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
div {
  display: block;
}

.logo {
  /* position: fixed; */
  left: 5rem;
}

.hero {
  position: relative;
  height: 35.625rem;
}
.child {
  width: 200px;
  height: 80px;
  background-color: transparent;
  position: absolute;
  top: 1rem;
  left: 1.875rem;
  z-index: 110;
}
.hero_image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #183330;
}
.image {
  position: relative;
  z-index: 98;
  overflow: hidden;
}
.covered {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hero_image.is-shown img {
  opacity: 1;
  height: 100%;
}
.brand-logo {
  position: relative;
}
.top-header__logo {
  margin-left: 1.25rem;
}
.top-header.is-visible {
  opacity: 1;
  transform: translateZ(0);
}
.top-header {
  display: flex;
  position: fixed;
  top: 1.875rem;
  left: 1.875rem;
  z-index: 99;
  transition: transform 0.7s cubic-bezier(0.22, 0.61, 0.36, 1),
    opacity 1s cubic-bezier(0.22, 0.61, 0.36, 1),
    -webkit-transform 0.7s cubic-bezier(0.22, 0.61, 0.36, 1);
}
.brand-logo__link {
  display: inline-flex;
  height: 3.75rem;
  -webkit-box-align: center;
  align-items: center;
  overflow: hidden;
}

a {
  transition: all 0.15s ease-in-out;
  text-decoration: none;
  background-color: transparent;
}

.brand-logo__svg {
  display: block;
  width: 6.25rem;
  height: 3.75rem;
  fill: var(--menu-color);
  transition: transform 0.65s cubic-bezier(0.22, 0.61, 0.36, 1),
    fill 0.8s cubic-bezier(0.22, 0.61, 0.36, 1),
    -webkit-transform 0.65s cubic-bezier(0.22, 0.61, 0.36, 1);
  transform: translate3d(0, -3.75rem, 0);
}
.svg-fill {
  stroke: none;
}
.svg-icon {
  color: inherit;
  vertical-align: middle;
}
svg {
  overflow: hidden;
}

//iPhone 5 //
@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .hero_image {
    width: 100%;
    height: 570px;
    overflow: hidden;
  }
}

// //Galaxy S5/S8/Moto S4  and Note 3//
// @media screen and (device-width: 320px) and (device-height: 640px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape) {
// .hero_image {
//     width: 100%;
//     height: 640px;
//     overflow: hidden;
// }
// }

/* ----------- iPhone 6, 6S, 7 and 8 ----------- */
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .hero_image {
    width: 100%;
    height: 670px;
    overflow: hidden;
  }
}

//iPhone 6/7/8 Plus/11 //
@media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  .hero_image {
    width: 100%;
    height: 740px;
    overflow: hidden;
  }
}

//iPhone 6/7/8/X/11Pro/12 Mini //
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  .hero_image {
    width: 100%;
    height: 812px;
    overflow: hidden;
  }
}
</style>
